export default {
  route: {
    "title": "정보 게시 시스템",
    "home": "홈",
    "terminal": "터미널",
    "program": "프로그램",
    "h5program": "프로그램",
    "my": "내",
    "remote_control": "리모컨",
    "task_details": "작업 세부 정보",
    "add_task": "작업 추가",
    "program_list": "프로그램 목록",
    "terminal_info": "터미널 정보",
    "add_resolution": "해상도 추가",
    "add_program": "프로그램 추가",
    "material_management": "자료 관리",
    "create_program": "프로그램 생성",
    "login": "로그인",
    "reset_password": "비밀번호 재설정",
    "change_password": "비밀번호 변경",
    "preview": "미리보기"
  },
  append_field:{
    "input_code": "인증 코드를 입력하세요",
    "code_error": "인증 코드 오류",
    "fill_code": "인증 코드를 입력하세요",
    "dOut": "3D 회전 나가기",
    "dIn": "3D 회전 들어가기",
    "dxiao": "3D 그림 효과",
    "selectImage": "이미지를 선택하세요",
    "onlySelectOneImage": "이미지 하나만 선택할 수 있습니다",
    "imageFormatError": "이미지 형식 오류",
    "cancel": "취소",
    "selectedNumber": "선택됨",
    "confirm": "확인",
    "loadinga": "로딩 중...",
    "loadingb": "로딩 중",
    "uploading": "업로드 중",
    "selectStartDates": "시작 날짜를 선택하세요",
    "selectEndDates": "종료 날짜를 선택하세요",
    "createTask": "새 작업 만들기",
    "selectPrograms": "프로그램 선택",
    "createPrograms": "새 프로그램 만들기",
    "editTask": "작업 수정",
    "fillTaskName": "이름을 입력하세요",
    "selectTaskGroup": "작업 그룹을 선택하세요",
    "selectProgram": "프로그램을 선택하세요",
    "selected": "선택됨",
    "programs": "개 프로그램",
    "selectDevice": "장치를 선택하세요",
    "sendTaskSuccess": "작업 전송 성공",
    "taskName": "이름",
    "playMode": "재생 모드",
    "replaceMode": "교체 모드",
    "appendMode": "추가 모드",
    'apotpatterns': '삽입 모드',
    "dateRange": "재생 날짜",
    "timeRange": "재생 시간",
    "taskPeriod": "지정 요일",
    "mon": "월",
    "tue": "화",
    "wed": "수",
    "thu": "목",
    "fri": "금",
    "sat": "토",
    "sun": "일",
    "back": "돌아가기",
    "programList": "프로그램 목록",
    "deviceList": "장치 목록",
    "enterContent": "내용을 입력하세요",
    "taskGroup": "작업 그룹",
    "selectStartDate": "시작 날짜를 선택하세요",
    "selectEndDate": "종료 날짜를 선택하세요",
    "selectStartTime": "시작 시간을 선택하세요",
    "selectEndTime": "종료 시간을 선택하세요",
    "addTask": "작업 추가",
    "topLeft": "왼쪽 상단",
    "topCenter": "상단 중앙",
    "topRight": "오른쪽 상단",
    "leftCenter": "왼쪽 중앙",
    "center": "중앙",
    "rightCenter": "오른쪽 중앙",
    "bottomLeft": "왼쪽 하단",
    "bottomCenter": "하단 중앙",
    "bottomRight": "오른쪽 하단",
    "enterText": "문자를 입력하세요",
    "fontColor": "글꼴 색상",
    "bgColor": "배경 색상",
    "scrollDirection": "스크롤 방향",
    "scrollSpeed": "스크롤 속도",
    "fontSize": "글꼴 크기",
    "alignment": "정렬 방식",
    "subtitle": "자막",
    "enterURL": "URL을 입력하세요",
    "webPage": "웹 페이지",
    "enterMediaURL": "스트리밍 주소를 입력하세요",
    "media": "스트리밍",
    "selectVideo": "비디오를 선택하세요",
    unsupportedFormat: '지원되지 않는 파일 형식입니다. 자세한 지원 형식은 내 - 시스템 도움말을 참조하십시오.',
    "cancelAllSelections": "새 파일을 업로드하기 전에 선택한 모든 자료를 취소하세요",
    "fileName": "파일 이름",
    "fileSize": "파일 크기",
    "uploadProgress": "업로드 진행",
    "cancelUpload": "업로드 취소",
    "cancelAllUploads": "모든 업로드 취소",
    "leftToRights": "왼쪽에서 오른쪽으로",
    "rightToLefts": "오른쪽에서 왼쪽으로",
    "bottomToTops": "아래에서 위로",
    "static": "정지",
    "slow": "느린",
    "medium": "중간",
    "fast": "빠른",
    "colorValue": "색상 값",
    "defaultEffect": "기본 효과",
    "rightToLeft": "오른쪽에서 왼쪽으로",
    "leftToRight": "왼쪽에서 오른쪽으로",
    "topToBottom": "위에서 아래로",
    "bottomToTop": "아래에서 위로",
    "accordionSqueeze": "아코디언 압축",
    "zoomInFade": "확대 페이드",
    "zoomOutFade": "축소 페이드",
    "depthOfField": "심도 페이드",
    "leftRightRotate": "좌우 회전",
    "upDownRotate": "상하 회전",
    "counterclockwiseRotate": "반시계 방향 회전",
    "clockwiseRotate": "시계 방향 회전",
    "upDownZoom": "상하 확대",
    "scaleFade": "확대 페이드",
    "zoomInDisappearing": "확대 사라짐 애니메이션",
    "transparentFade": "투명 페이드",
    "gradientScale": "그라데이션 확대",
    "deleteMaterial": "소재 삭제",
    "confirmDeleteMaterial": "이 소재를 삭제하시겠습니까?",
    "unreviewed": "검토되지 않음",
    "normal2": "정상",
    "violating": "위반",
    "suspectedViolating": "의심되는 위반",
    "delete": "삭제",
    "selectMaterial": "소재를 선택하세요",
    "deleteProgramGroup": "프로그램 그룹 삭제",
    "confirmDeleteGroup": "이 그룹을 삭제하시겠습니까?",
    "add": "추가",
    "toggle_effect": "효과 전환",
    "toggle_time": "시간 전환",
    "pub_toggle_time": "통일된 전환 시간",
    "fullscreen": "전체 화면",
    "normal": "일반",
    "interactive": "상호작용",
    "main_screen": "주 화면",
    "sub_screen": "부 화면",
    "dual_screen": "듀얼 스크린",
    "sync_task": "작업 동기화",
    "normal_mode": "일반 모드",
    "basic_info": "기본 정보",
    "program_info": "프로그램 정보",
    "task_name": "프로그램 이름",
    "task_type": "작업 유형",
    "pub_task": "일반 작업",
    "hu_task": "상호작용 작업",
    "no_data": "데이터 없음",
    "no_msg": "메시지 없음",
    "program_name": "프로그램 이름",
    "program_resolution": "프로그램 해상도",
    "program_type": "프로그램 유형",
    "screen_category": "화면 카테고리",
    "edit_program": "프로그램 편집",
    "edit": "편집",
    "send": "전송",
    "create": "그룹 생성",
    "reload": "새로 고침",
    "name": "이름",
    "create_task_z": "작업 그룹 생성",
    "ps_push_name": "그룹명을 입력하세요",
    "device_list": "장치 목록",
    "delete_task_group": "작업 그룹 삭제",
    "confirm_delete_group": "이 그룹을 삭제하시겠습니까?",
    "delete_success": "삭제 성공",
    "name_cannot_be_empty": "이름은 비워둘 수 없습니다",
    "character_length_limit": "문자 길이는 10자 이내여야 합니다",
    "create_task_success": "작업 생성 성공",
    "create_task_failed": "생성 실패",
    "confirm_delete_task": "작업을 삭제하시겠습니까?",
    "task_details": "작업 세부정보",
    "download_success": "다운로드 성공",
    "waiting_download": "다운로드 대기 중",
    "downloading": "다운로드 중",
    "confirm_delete": "삭제하시겠습니까?",
    "confirm_delete_all": "모두 삭제하시겠습니까?",
    "confirm_delete_selected": "선택한 항목을 삭제하시겠습니까?",
    "no_data_to_clear": "지울 데이터가 없습니다!",
    "refresh": "새로 고침",
    "clear_all": "모두 지우기",
    "clear_completed": "완료된 항목 지우기",
    "device_id": "장치 ID",
    "task_size": "작업 크기",
    "speed": "속도",
    "download_progress": "다운로드 진행",
    "title": "제목",
    "volume": "음량",
    "deleteP": "프로그램 삭제",
    "con_P": "이 프로그램을 삭제하시겠습니까?",
    "clear": "비우기",
    "download_status": "다운로드 상태",
    "height_width_cannot_be_empty": "높이/너비는 비워둘 수 없습니다",
    "add_success": "추가 성공",
    "enter_number_between_300_to_8000": "300~8000 사이의 숫자를 입력하세요",
    "width": "너비",
    "enter_width": "너비를 입력하세요",
    "height": "높이",
    "enter_height": "높이를 입력하세요",
    "confirm_leave_page": "이 페이지를 떠나시겠습니까?",
    "add_content_to_control": "컨트롤에 내용을 추가하세요",
    "add_control": "컨트롤을 추가하세요",
    "save_success": "저장 성공",
    "save": "저장",
    "create_program": "프로그램 생성",
    "guess": "추측하세요",
    "modify": "수정",
    "text": "텍스트",
    "image": "이미지",
    "background_image": "배경 이미지",
    "background_music": "배경 음악",
    "replace": "교체",
    "use_this_template": "이 템플릿 사용",
    "apply_template": "템플릿 적용",
    "enter_program_name": "프로그램 이름을 입력하세요",
    "program_group": "프로그램 그룹",
    "select_program_group": "프로그램 그룹을 선택하세요",
    "group_list": "그룹 목록",
    "preview": "미리 보기",
    "my_apps": "내 앱",
    "template_center": "템플릿 센터",
    "home": "홈",
    "source_of_visit": "방문 출처",
    "online": "온라인",
    "terminal_status": "상태",
    "memory_status": "메모리 상태",
    "login": "로그인",
    "sms_verification": "문자 인증",
    "email_verification": "이메일 인증",
    "log_in": "로그인",
    "enter_username": "계정을 입력하세요",
    "username_cannot_be_empty": "사용자 이름은 비워둘 수 없습니다",
    "password_cannot_be_empty": "비밀번호는 비워둘 수 없습니다",
    "incorrect_phone_format_for_verification_code": "받은 인증 코드의 전화번호 형식이 잘못되었습니다. 관리자에게 수정 요청하세요!",
    "incorrect_email_format_for_verification_code": "받은 인증 코드의 이메일 형식이 잘못되었습니다. 관리자에게 수정 요청하세요!",
    "incorrect_phone_or_email_format_for_verification_code": "받은 인증 코드의 이메일 또는 전화번호 형식이 잘못되었습니다. 관리자에게 수정 요청하세요!",
    "reset_password": "비밀번호 재설정",
    "remember_password": "비밀번호 기억하기",
    "register": "계정 등록",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "네트워크 보안에 대한 알림",
    "got_it": "알겠습니다",
    "please_authenticate_for_account_safety": "계정 안전을 위해 인증을 진행하세요",
    "enter_account": "계정을 입력하세요",
    "enter_password": "비밀번호를 입력하세요",
    "verification_code": "인증 코드",
    "none": "없음",
    "personal_center": "개인 센터",
    "remote_control": "원격 제어",
    "refresh_success": "새로 고침 성공!",
    "logout": "로그아웃",
    "confirm_logout": "로그아웃 하시겠습니까?",
    "user_status": "사용자 상태",
    "customer_address": "고객 주소",
    "account_period": "계정 기간",
    "device_control": "장치 원격 제어",
    "clear_cache": "캐시 지우기",
    "exit": "종료",
    "terminal": "단말기",
    "program": "프로그램",
    "material": "자료",
    "my": "내",
    "display_type": "디스플레이 유형",
    "proportion": "비율",
    "resolution": "해상도",
    "screen_orientation": "화면 방향",
    "landscape": "가로",
    "portrait": "세로",
    "add_resolution": "해상도 추가",
    "execute_formatting_when_focus_lost": "포커스가 잃었을 때 포맷 실행",
    "select_resolution": "해상도를 선택하세요",
    "resolution_list": "해상도 목록",
    "confirm_delete_program": "프로그램을 삭제하시겠습니까?",
    "confirm_delete_this_program": "이 프로그램을 삭제하시겠습니까?",
    "bound_tasks_exists_confirm_delete": "바인딩된 작업이 있습니다. 삭제하시겠습니까?",
    "prompt": "프롬프트",
    "delete_failed": "삭제 실패",
    "modification_time": "수정 시간",
    "resolution_": "해상도",
    "associated_tasks": "연관된 작업",
    "bound_task": "바인딩된 작업",
    "program_management": "프로그램 관리",
    "task": "작업",
    "progress": "진행",
    "phone_number": "전화번호",
    "enter_phone_number": "전화번호를 입력하세요",
    "password": "비밀번호",
    "confirm_password": "비밀번호 확인",
    "enter_password_again": "비밀번호를 다시 입력하세요",
    "company_name": "회사명",
    "enter_company_name": "회사의 정보를 입력하세요",
    "address": "주소",
    "enter_address": "연락 주소를 입력하세요",
    "username_not_exist": "사용자 이름이 존재하지 않습니다",
    "enter_new_password": "새 비밀번호를 입력하세요",
    "enter_new_password_again": "새 비밀번호를 다시 입력하세요",
    "terminal_management": "단말 관리",
    "delete_group": "그룹 삭제",
    "pel_select_group": "그룹을 선택하세요",
    "enter_device_name": "장치 이름을 입력하세요",
    "delete_device": "장치 삭제",
    "confirm_delete_device": "이 장치를 삭제하시겠습니까?",
    "terminal_information": "단말 정보",
    "qr_code_error": "QR 코드 오류",
    "device_not_supported": "장치가 지원되지 않습니다",
    "device_offline": "선택한 장치는 온라인 상태여야 명령을 내릴 수 있습니다. 다시 선택하세요!",
    "more": "더보기",
    "device_access": "장치 접속",
    "filter": "필터",
    "all": "모두",
    "offline": "오프라인",
    "device_name": "장치 이름",
    "device_number": "장치 번호",
    "device_group": "장치 그룹",
    "call_device_please_wait": "장치를 호출 중입니다. 잠시 기다려 주세요...",
    "create_terminal_group": "새 장치 목록 그룹 생성",
    "enter_search_keyword": "검색 키워드를 입력하세요",
    "bind_device": "장치 바인딩",
    "select_device_group": "장치 그룹을 선택하세요",
    "authorized": "허가됨",
    "unauthorized": "허가되지 않음",
    "adjust_volume": "볼륨 조절",
    "reboot_device": "장치 재부팅",
    "wake_up": "깨우기",
    "sleep": "절전",
    "shutdown": "종료",
    "clean_up_timing_on_off": "청소 타이밍",
    "clean_up_disk": "디스크 정리",
    "clean_up_task": "작업 정리",
    "send_command": "명령 전송",
    "confirm2": "전송하시겠습니까?",
    "terminal_operation": "단말 작업",
    "bind_task": "작업 정보",
    "remote_command": "원격 명령",
    "remote_monitor": "원격 모니터링",
    "adding_one_will_override_the_previous": "하나만 추가할 수 있으며, 이전 기록을 덮어씁니다",
    "screenshot_in_progress_please_wait": "스크린샷을 찍는 중입니다. 잠시 기다려 주세요",
    "schedule_on_off": "정기적 전원 켜기/끄기",
    "shutdown_time": "종료 시간",
    "startup_time": "시작 시간",
    "volume_setting": "볼륨 설정",
    "edit_device_name": "장치 이름 편집",
    "please_select_time": "시간을 선택하세요",
    "device_not_online_please_retry": "장치가 온라인이 아닙니다. 다시 시도하세요",
    "sent_successfully": "전송 성공",
    "version": "V4.1.8",
    "texta": "텍스트",
    "userName": "계정",
    "email": "이메일",
    "device_memory": "장치 메모리",
    "device": "장치",
    "device_mac": "장치 MAC",
    "screen_count": "화면 수",
    "device_location": "장치 위치",
    "is_authorized": "허가됨",
    "remark": "비고",
    "device_ip": "장치 IP",
    "system_version": "시스템 버전",
    "playback_date": "재생 날짜",
    "playback_period": "재생 기간",
    "retrieve_again": "다시 가져오기",
    "please_enter_password": "8자리 이상의 숫자, 문자, 특수 문자[@#$%^&+=]를 포함한 비밀번호를 입력하세요!",
    "passwords_do_not_match": "입력한 두 비밀번호가 일치하지 않습니다",
    "enter_new_password2": "새 비밀번호 입력",
    "current_password_too_simple": "현재 비밀번호가 너무 간단합니다. 계정 안전을 위해 8자리 이상의 숫자, 문자, 특수 문자[@#$%^&+=]를 포함한 비밀번호로 변경하세요",
    "creation_time": "생성 시간",
    "login2": "로그인",
    "welcome": "로그인에 오신 것을 환영합니다",
    "expired_login": "인증이 만료되었습니다. 다시 로그인하세요.",
    "control": "원격 제어",
    "add_task": "작업 추가",
    "program_list": "프로그램 목록",
    "terminal_info": "단말 정보",
    "add_program": "프로그램 추가",
    "material_management": "자료 관리",
    "change_password": "비밀번호 변경",
    "enter_text_content": "텍스트 내용을 입력하세요",
    "hit_the_wall_on_back": "뒤로 가면 벽입니다",
    "last_ceremony": "마지막 의식",
    "already_top_level": "이미 최상위입니다",
    "already_last_one": "이미 마지막입니다",
    "white_fox": "흰 여우",
    "control_img": "이미지",
    "control_video": "비디오",
    "control_streaming": "스트리밍",
    "control_webPage": "웹사이트",
    "control_subtitle": "자막",
    "control_HDMI": "HDMI",
    "control_addbackground": "배경 추가",
    "Up": "업로드",
    "onlyOne": "컨트롤은 하나만 추가할 수 있습니다",
    "clearBg": "배경 지우기",
    "get_code": "먼저 인증 코드를 입력하세요",
    "del_Null_Program": "목록에서 내용이 비어 있는 프로그램을 비워도 될까요?",
    "please_select_date": "최소한 하나의 날짜를 선택하세요",
    "last_size": "남은 공간",
    "shutdown_tips": "전원 끄기 후 원격으로 켤 수 없습니다",
    "last_size_upload": "다시 선택해 주세요.",
    "end_date_earlier_than_start_date": "종료 날짜는 시작 날짜보다 빨라서는 안 됩니다",
    "account_type": "사용자 유형",
    "user_type": "일반 사용자",
    "role_type": "역할",
    "super_administrator": "슈퍼 관리자",
    "term_info_empty": "단말 정보가 비어 있습니다",
    "select_terminal_prompt": "오른쪽 상단의 목록 버튼을 클릭하여 단말을 선택하세요",
    "select": "선택",
    "data_empty": "데이터가 비어 있습니다!",
    "content_review": "내용 검토",
    "start_date": "시작 날짜",
    "end_date": "종료 날짜",
    "start_time": "시작 시간",
    "end_time": "종료 시간",
    "select_all": "모두 선택",
    "select_group": "그룹 선택",
    "review": "검토",
    "material_type": "소재 유형",
    "audio": "오디오",
    "document": "문서",
    "material_status": "소재 상태",
    "material_review": "소재 검토",
    "current_selection_requires_review": "현재 선택한 소재, 검토가 필요합니까?",
    "invCode": "초대 코드",
    "tip_invitation_empty": "초대 코드를 입력하세요",
    "enter_userName": "사용자 계정을 입력하세요",
    "enter_email": "이메일을 입력하세요",
    "file_less_38": "파일 크기가 1KB 미만이어야 합니다",
    "viewError": "이 파일은 미리보기를 지원하지 않습니다",
    "user": "개인 정보",
    "phone_number_too_short": "전화번호 길이가 9자리 이상이어야 합니다",
    "oneImage": "배경 이미지가 이미 존재합니다. 다시 업로드하려면 먼저 삭제하세요",
    "del_title": "삭제 확인",
    "del_message": "컨트롤을 삭제하시겠습니까?",
    "close": "닫기",
    "exit_group_name": "그룹 이름 편집",
    "group_management": "그룹 관리",
    "language": "언어 전환",
    "mixture": "혼합 방송",
    "date": "날짜",
    "weeks": "주",
    "time": "시간",
    "new_password": "새 비밀번호",
    "enter_invCode": "친절한 안내: 초대 코드는 상위 관리자에게 요청하세요",
    "msg_password": "친절한 안내: 8자리 이상의 숫자, 문자, 특수 문자[@#$%^&+=]를 포함한 비밀번호를 입력하세요!",
    "oneDoc": "문서가 이미 존재합니다. 다시 업로드하려면 먼저 삭제하세요",
    "Sunday": "일요일",
    "Monday": "월요일",
    "Tuesday": "화요일",
    "Wednesday": "수요일",
    "Thursday": "목요일",
    "Friday": "금요일",
    "Saturday": "토요일",
    "input_error": "모든 필드는 비워 둘 수 없습니다",
    video_tutorial:'자료',
    "view": "온라인 보기",
    "selectDeviceOne": "이 명령은 단 하나의 장치만 선택할 수 있습니다",
    "select_device_list": "선택한 장치 목록",
    "small_size": "작은",
    "medium_size": "중간",
    "large_size": "큰",
    device_info:'장치 정보',
    "notification": "알림",
    "notif_title": "알림 내용",
    "notif_msg": "2024년 11월 5일부터 ETV 서비스 센터는 1년 이상 저장된 자료를 삭제합니다. 중요 자료는 미리 백업해 주시기 바랍니다. 이해와 협조에 감사드립니다.",
    reduce:'축소',
    bound_material: '바인드된 소재',
    tip_material: '바인드된 프로그램의 소재는 삭제할 수 없습니다. 먼저 소재의 바인드를 해제하세요.',
    boundpo: '바인드된 프로그램',
    bind_progron: '이 소재는 프로그램에 바인드되어 있어 삭제할 수 없습니다.',
    index: '인덱스',
    source: '출처',
    getUploadSet_tip: '소재 업로드 금지 실패.',
    getUploadstartTime_tip: '현재 시간에 소재 업로드가 금지되어 있습니다. 금지되지 않은 시간에 업로드해 주세요.',
    getUploadendTim: '소재 업로드 금지',
    "download": "다운로드",
    program_review: '프로그램 검토',
    pass: '통과',
    not_passed_or_not_reviewed: '불합격 또는 미검토',
    play_mode: '재생 모드',
    review_status: '검토 상태',
    reject: '거부',
    review_content: '검토 내용',
    enter_review_content: '검토 내용을 입력하십시오',
    device_quantity: "장치 수",
    system_help: '시스템 도움말',
    updateInfo: '업데이트 정보',
    Formatspecification: '형식 설명',
    fileFormat: '파일 형식',
    imgFormat: '이미지 형식',
    audioFormat: '오디오 형식',
    videoFormat: '비디오 형식',
    updated: '업데이트 날짜',
    details: '1: 내 - 시스템 도움말 메뉴 추가<br>2: 새로운 업로드 자료 유형, Tencent 클라우드 업로드, PC 설정과 동기화 추가<br>3: 자료 및 프로그램 자료 표시 기능 최적화',
    nameLengthLimit: '이름 길이를 50자 이내로 제한하십시오',
    "customer_title": "계정 조회",
    "authorized_devices": "승인된 기기 대수",
    "enable": "활성화",
    "disable": "비활성화",
    "expired": "계정 만료",
    "valid_date": "유효 날짜",
    "valid_date_placeholder": "유효 날짜 입력",
    "capacity_rule": "서버 용량은 100의 배수여야 합니다",
    "capacity_label": "서버 용량 (MB)",
    "download_speed": "다운로드 속도 제한",
    "submit_btn": "제출",
    sub_accounts: '하위 계정 수정만 지원됩니다',
    plan_mode: '계획 모드',
    default_mode: '기본 모드',
    "noMore": "더 이상 없음",
    "help": "사용 도움말",
    "apk_download": "APK 다운로드",
    "android": "안드로이드",
    "ios": "iOS",
    "app_name": "ETV-H5 정보 배포 어시스턴트",
    "info_publish": "정보 배포",
    "upload_material": "자료 업로드",
    "img_size": "이미지 픽셀 이상, 확인 후 업로드해 주세요.",
    "file_size_exceed_skip": "파일 크기는 다음을 초과할 수 없습니다",
    "processing": "처리 중",
    "failed": "실패",
    "aliyun_storage_support": "알리클라우드 저장소는 더 많은 형식을 지원합니다",

  },
  vanDialog: {
    confirm: '확인',
    cancel: '취소'
  },
  vanPicker: {
    confirm: '확인',
    cancel: '취소',
  },
  vanDatetimePicker: {
    title: '날짜 선택',
  },
}